import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { onTabChange } from 'analytics-plugin-tab-events';
import { onAnalyticsUnload, track } from '../analytics';
import { WebsiteEvents } from '../constants/events';
var defaultOptions = {
  enabled: true
};
/**
 * This tracker is used to track tab exit event.
 * It's dispatched when the user switches to another tab or closes the browser.
 */

export var tabExitEventTracker = function tabExitEventTracker(options) {
  options = _objectSpread(_objectSpread({}, defaultOptions), options);

  if (!options.enabled) {
    return;
  }

  var removeListener = onTabChange(function (isHidden) {
    if (isHidden) {
      track(WebsiteEvents.TAB_EXITED);
    }
  });
  onAnalyticsUnload(removeListener);
};